import http from "./httpService";
import { getJwt } from "./authService";

const confige = {
  headers: { Authorization: `Bearer ${getJwt()}` },
};

export function getArticles(kind) {
  return http.get(`${process.env.REACT_APP_PUBLIC_PATH}docs/articles/${kind}`);
}

export function getSingleArticle(id) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/single-article/${id}`
  );
}

export function getBooks() {
  return http.get(`${process.env.REACT_APP_PUBLIC_PATH}docs/books`);
}

export function getUserBooksId() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/user-books-id`,
    confige
  );
}

export function getMyBooks() {
  return http.get(`${process.env.REACT_APP_PUBLIC_PATH}docs/my-books`, confige);
}

export function getMyQuarterlys() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/my-quarterlys`,
    confige
  );
}

export function getQuarterlys() {
  return http.get(`${process.env.REACT_APP_PUBLIC_PATH}docs/quarterlys`);
}

export function getUserQuarterlysId() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/user-quarterlys-id`,
    confige
  );
}

export function getEldersWords() {
  return http.get(`${process.env.REACT_APP_PUBLIC_PATH}docs/elders-words`);
}

export function getSingleBook(bookId) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/single-book/${bookId}`,
    confige
  );
}

export function getSingleBookNotBuyed(bookId) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/single-book-not-buyed/${bookId}`
  );
}

export function getSingleQuarterlyNotBuyed(quarterlyId) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/single-quarterly-not-buyed/${quarterlyId}`
  );
}

export function getSingleQuarterly(quarterlyId) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/single-quarterly/${quarterlyId}`,
    confige
  );
}

export function getSubscriptions(kind) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/subscriptions/${kind}`,
    confige
  );
}

export function getBookPage(bookId, pageNumber) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/private/images/${pageNumber}/${bookId}`,
    { ...confige, responseType: "blob" }
  );
}

export function getBookPdf(bookId) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/private/bookPdf/${bookId}`,
    { responseType: "arraybuffer", ...confige }
  );
}

export function getQuarterlyPage(quarterlyId, pageNumber) {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}docs/private/quarterly/images/${pageNumber}/${quarterlyId}`,
    { ...confige, responseType: "blob" }
  );
}

export function getNotifications() {
  return http.get(`${process.env.REACT_APP_PUBLIC_PATH}docs/notification`);
}
